import { AxiosRequestConfig, AxiosResponse } from "axios";
import { ODataMultipleResponse, ODataBaseResponse } from "@/models/responses/odata.response.interface";
import { ApiService } from "./api.service";
import { TagReponse } from "@/models/responses/tag.response.interface";
import { SUSCRIPTION_KEY } from "@/constants/config";

interface TagModelResponse extends ODataBaseResponse {
  rs_tag: string;
  rs_equipoid: string;
  _rs_equipoid_value: string;
  rs_name: string;
  rs_rutabroker: string;
}

interface URLConsume {
  urlBase: string;
  pathCurp: string;
  pathRfc: string;
  pathNss: string;
}

class VariablesService extends ApiService {
  public constructor(config?: AxiosRequestConfig) {
    super(config);

    this.findDescription = this.findDescription.bind(this);
    this.getBrokers = this.getBrokers.bind(this);
    this.findDecimalValue = this.findDecimalValue.bind(this);
    this.findMessageSms = this.findMessageSms.bind(this);
  }

  /**
   * Find the Description variable by its Name
   *
   * @param {string} name
   * @returns {Promise<string>}
   * @memberof VariablesService
   */
  public async findDescription(name: string): Promise<string> {
    const res = await this.get<{ rs_descripcion: string }, AxiosResponse<ODataMultipleResponse<{ rs_descripcion: string }[]>>>(
      `d365api/v1/rs_variabledelsistemas?$filter=rs_name eq '${name}'&$select=rs_descripcion`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (res.data.value.length <= 0) return "";
    return res.data.value[0].rs_descripcion;
  }

  public async getBrokers(tag: string): Promise<TagReponse> {
    const response: TagReponse = {
      tag: "",
      teamId: "",
      teamName: ""
    };

    if (tag !== undefined && tag !== "") {
      const rest = await this.get<TagReponse, AxiosResponse<ODataMultipleResponse<TagModelResponse[]>>>(`d365api/v1/rs_tagsportals?$select=rs_tag,_rs_equipoid_value,rs_rutabroker,rs_name`, {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      });

      for (let index = 0; index < rest.data.value.length; index++) {
        const element = rest.data.value[index];
        if (element.rs_tag.toLowerCase() == tag.toLowerCase()) {
          response.teamId = element._rs_equipoid_value;
          response.teamName = element._rs_equipoid_value;
          response.tag = element.rs_tag;
        }
      }
    }

    return response;
  }

  public async schedule(): Promise<boolean> {
    //let isOn = true; //false;

    // const res = await this.get<{ description: string; schemaname: string }, AxiosResponse<ODataMultipleResponse<{ description: string; schemaname: string }[]>>>(
    //   `d365api/v1/environmentvariabledefinitions`,
    //   {
    //     headers: {
    //       "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
    //     }
    //   }
    // );

    // if (res.data.value.length <= 0) return isOn;

    // for (let index = 0; index < res.data.value.length; index++) {
    //   const element = res.data.value[index];
    //   if (element.schemaname == "rs_VariablePortal") {
    //     const dateCompare = JSON.parse(res.data.value[index].description);
    //     const startDate = dateCompare.Start;
    //     const endDate = dateCompare.End;

    //     const today = new Date();
    //     const compareStart = new Date();
    //     const compareEnd = new Date();

    //     if (startDate != undefined && startDate != "") {
    //       const schedule1 = startDate.split(":");
    //       const hour = schedule1[0];
    //       const min = schedule1[1];
    //       compareStart.setHours(hour, min);
    //     }

    //     if (endDate != undefined && endDate != "") {
    //       const schedule2 = endDate.split(":");
    //       const hour = schedule2[0];
    //       const min = schedule2[1];
    //       compareEnd.setHours(hour, min);
    //     }

    //     if (today > compareStart && today < compareEnd) {
    //       isOn = true;
    //     } else {
    //       isOn = false;
    //     }
    //   }
    // }

    return true; //isOn;
  }

  /**
   * Find the Decimal value variable by its Name
   *
   * @param {string} name
   * @returns {Promise<number>}
   * @memberof VariablesService
   */
  public async findDecimalValue(name: string): Promise<number> {
    const res = await this.get<{ rs_valordecimal: string }, AxiosResponse<ODataMultipleResponse<{ rs_valordecimal: number }[]>>>(
      `d365api/v1/rs_variabledelsistemas?$filter=rs_name eq '${name}'&$select=rs_valordecimal`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (res.data.value.length <= 0) return 0;
    return res.data.value[0].rs_valordecimal;
  }

  /**
   * Find the defaultvalue by its Name
   * @param {string} name
   * @returns {Promise<number>}
   * @memberof VariablesService
   */
  public async timeWaitSendSms(name: string): Promise<number> {
    const url = `d365api/v1/environmentvariabledefinitions?$filter=schemaname eq '${name}'&$select=defaultvalue`;
    const seconds = await this.get<{ defaultvalue: number }, AxiosResponse<ODataMultipleResponse<{ defaultvalue: number }[]>>>(url, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });
    if (seconds.data !== null && seconds.data.value.length > 0) return seconds.data.value[0].defaultvalue;
    else return null;
  }

  public async findMessageSms(name: string): Promise<string> {
    const res = await this.get<{ defaultvalue: string }, AxiosResponse<ODataMultipleResponse<{ defaultvalue: string }[]>>>(
      `d365api/v1/environmentvariabledefinitions?$filter=schemaname eq '${name}'&$select=defaultvalue`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (res.data.value.length <= 0) return "";
    return res.data.value[0].defaultvalue;
  }

  /**
   * Gets the value of Release Letter ID
   * @param {string} name
   * @returns {Promise<string>}
   * @memberof ImssService
   */

  public async getEnviromentVariable(name: string): Promise<string> {
    const url = `d365api/v1/environmentvariabledefinitions?$filter=schemaname eq '${name}'&$select=defaultvalue`;
    const defValue = await this.get<{ defaultvalue: string }, AxiosResponse<ODataMultipleResponse<{ defaultvalue: string }[]>>>(url, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });
    if (defValue.data.value.length <= 0) return null;
    return defValue.data.value[0].defaultvalue;
  }

  public async findVariableValue(name: string): Promise<string> {
    const res = await this.get<{ rs_valor: string }, AxiosResponse<ODataMultipleResponse<{ rs_valor: string }[]>>>(`d365api/v1/rs_variabledelsistemas?$filter=rs_name eq '${name}'&$select=rs_valor`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    if (res.data.value.length <= 0) return "";
    return res.data.value[0].rs_valor;
  }

  public async getURLConsume(path: string): Promise<string> {
    const res = await this.get<URLConsume, AxiosResponse<ODataMultipleResponse<URLConsume>>>(
      `d365api/v1/environmentvariabledefinitions?$filter=schemaname eq 'rs_nubarium_urlapis'&$select=defaultvalue`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (res.data.value == null) return "";
    else {
      const element = JSON.parse(res.data.value[0]["defaultvalue"]);
      if (path == "curp") return element.pathCurp;
      else if (path == "rfc") return element.pathRfc;
      else if (path == "nss") return element.pathNss;
      else if (path == "sat") return element.pathValidateRfc;
      else return "";
    }
  }
}

export const variablesService = new VariablesService();
